import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, MailCheck, MailX } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "verifying", message: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState({ status: "error", message: "Missing verification token." }); return; }
    api.post("/auth/verify-email", { token })
      .then((r) => setState({ status: "ok", message: r.data.message }))
      .catch((e) => setState({ status: "error", message: formatApiErrorDetail(e.response?.data?.detail) || "Verification failed." }));
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-md rounded-xl border bg-white p-8 text-center shadow-sm" data-testid="verify-email-card">
        {state.status === "verifying" && (
          <><Loader2 className="mx-auto h-10 w-10 animate-spin text-kilted-green" />
            <p className="mt-4 text-sm text-muted-foreground">Verifying your email…</p></>
        )}
        {state.status === "ok" && (
          <><MailCheck className="mx-auto h-10 w-10 text-emerald-600" />
            <h1 className="mt-4 font-heading text-2xl font-extrabold text-kilted-green">Email verified!</h1>
            <p className="mt-2 text-sm text-muted-foreground" data-testid="verify-success-message">{state.message}</p>
            <Button asChild className="mt-6 w-full bg-kilted-green hover:bg-kilted-greenLight" data-testid="verify-continue-button">
              <Link to="/dashboard">Go to my dashboard</Link>
            </Button></>
        )}
        {state.status === "error" && (
          <><MailX className="mx-auto h-10 w-10 text-red-500" />
            <h1 className="mt-4 font-heading text-2xl font-extrabold text-kilted-green">Verification problem</h1>
            <p className="mt-2 text-sm text-muted-foreground" data-testid="verify-error-message">{state.message}</p>
            <Button asChild variant="outline" className="mt-6 w-full border-kilted-green text-kilted-green">
              <Link to="/dashboard">Back to dashboard</Link>
            </Button></>
        )}
      </div>
    </div>
  );
}
